import Link from 'next/link';
import { useSelector } from 'react-redux';
import { Banner } from 'components/Banner';
import { readableDayMonth, unix } from 'util/formatting/dates';

const variantLinkStyles = {
  ['error']: 'text-white underline',
  ['warning']: 'text-black underline',
  ['info-light']: 'text-primary-pure-blue',
};

export const MessagesRemainingBanner = () => {
  const subscription = useSelector((state) => state.employer.subscription);
  const employer = useSelector((state) => state.employer.employer);

  if (!subscription?.id || subscription?.messagesRemainingThisCycle === 'unlimited') return null;

  const isFreePlan = employer.isFreePlan?.();
  const messageLimit = subscription.plan().messageLimit;

  if (!messageLimit && !isFreePlan) return null;

  let variant = 'outline';
  let intent = 'info';
  if (!isFreePlan) {
    if (subscription.messagesRemainingThisCycle < 10) {
      intent = 'warning';
      variant = 'solid';
    }
    if (subscription.messagesRemainingThisCycle < 5) {
      intent = 'error';
      variant = 'solid';
    }
  }

  const linkStyle = variantLinkStyles[variant];

  return (
    <div className="mb-5">
      <Banner variant={variant} intent={intent}>
        <div className="text-center">
          {isFreePlan ? (
            <>
              <p>
                To send a message to your Applicants, go to your Applicants page{' '}
                <Link href="/employer/applicants" className="underline">
                  here
                </Link>
                .
              </p>
            </>
          ) : (
            <>
              <p>
                You have {subscription.messagesRemainingThisCycle} message credits remaining on your
                plan, which will reset on {readableDayMonth(unix(subscription.currentPeriodEnd))}
              </p>
              <Link href="/employer/profile#plan" className={linkStyle}>
                Click here to manage your plan
              </Link>
            </>
          )}
        </div>
      </Banner>
    </div>
  );
};
